import axios from 'axios'
import * as apiroutes from '../../apiroutes'
import localStorageService from './localStorageService'
import jwtDecode from 'jwt-decode'

class UserServices {
    // create new user
    createNewUser = async (data) => {
        // const accessToken = await localStorageService.getItem("accessToken");
        const a = new Promise((resolve, reject) => {
            axios
                .post(apiroutes.CREATE_USER, data)
                .then((res) => {
                    return resolve(res)
                })
                .catch((error) => {
                    console.log('error', error)
                    return resolve(error)
                })
        })
        return await a
    }

    //Get All district
    getEmployees = async (params) => {
        const accessToken = await localStorageService.getItem("accessToken");
        // debugger
        console.log("accessToken", accessToken);
        const a = new Promise((resolve, reject) => {
            axios.get(apiroutes.EMPLOYEES, {
                params: params,
                headers: {

                    Authorization: `Bearer ${accessToken}`
                    // Authorization: `Bearer ${'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOiJ0ZXN0Iiwicm9sZSI6MSwiaWF0IjoxNjY2MDA0NjA2LCJleHAiOjE2NjYzNjQ2MDZ9.CUnkweojyIlcs1HmIMwb1S9bjyRxzzzD-WGyy2LPvT8'}`
                }
            }).then((res) => {
                return resolve(res);
            })
                .catch((error) => {
                    console.log("error emp", error);
                    return resolve(error);
                })
        });
        // console.log("USERS",a);
        return await a;
    }

    
    getIndividualUsers = async (params) => {
        const accessToken = await localStorageService.getItem("accessToken");
        // debugger
        console.log("accessToken", accessToken);
        const a = new Promise((resolve, reject) => {
            axios.get(apiroutes.INDIVIDUAL_EMPLOYEES, {
                params: params,
                headers: {

                    Authorization: `Bearer ${accessToken}`
                    // Authorization: `Bearer ${'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOiJ0ZXN0Iiwicm9sZSI6MSwiaWF0IjoxNjY2MDA0NjA2LCJleHAiOjE2NjYzNjQ2MDZ9.CUnkweojyIlcs1HmIMwb1S9bjyRxzzzD-WGyy2LPvT8'}`
                }
            }).then((res) => {
                return resolve(res);
            })
                .catch((error) => {
                    console.log("error emp", error);
                    return resolve(error);
                })
        });
        // console.log("USERS",a);
        return await a;

    }
    myProfile = async (params) => {
        const accessToken = await localStorageService.getItem("accessToken");
        // debugger
        console.log("accessToken", accessToken);
        const a = new Promise((resolve, reject) => {
            axios.get(apiroutes.MY_PROFILE, {
                params: params,
                headers: {
                    Authorization: `Bearer ${accessToken}`
                 }
                }).then((res) => {
                    return resolve(res);
                })
                .catch((error) => {
                    console.log("error emp", error);
                    return resolve(error);
                })
        });
        // console.log("USERS",a);
        return await a;

    }

    getIndividualContributorsForOrgAdmin = async (params) => {
        const accessToken = await localStorageService.getItem("accessToken");
        // debugger
        // console.log("accessToken", accessToken);
        const a = new Promise((resolve, reject) => {
            axios.get(apiroutes.ORGADMIN_USER_MANAGEMENT, {
                params: params,
                headers: {
                    Authorization: `Bearer ${accessToken}`
                }
            }).then((res) => {
                return resolve(res);
            })
                .catch((error) => {
                    console.log("error emp", error);
                    return resolve(error);
                })
        });
        // console.log("USERS",a);
        return await a;

    }

    approveIndividualContributorsForOrgAdmin = async (data) => {
        console.log("Approval",data)
        const accessToken = await localStorageService.getItem("accessToken");
        const a = new Promise((resolve, reject) => {
            axios
                .post(apiroutes.ORGADMIN_USER_MANAGEMENT, data, {
                    headers: {
                        Authorization: `Bearer ${accessToken}`
                    }
                })
                
                .then((res) => {
                    return resolve(res)
                })
                .catch((error) => {
                    console.log('error', error)
                    return resolve(error)
                })
        })
        console.log("res @ UA",a)
        return await a

    }
    getOrganizationalUsers = async (params) => {
        const accessToken = await localStorageService.getItem("accessToken");
        // debugger
        console.log("accessToken", accessToken);
        const a = new Promise((resolve, reject) => {
            axios.get(apiroutes.ORGANIZATIONAL_EMPLOYEES, {
                params: params,
                headers: {

                    Authorization: `Bearer ${accessToken}`
                    // Authorization: `Bearer ${'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOiJ0ZXN0Iiwicm9sZSI6MSwiaWF0IjoxNjY2MDA0NjA2LCJleHAiOjE2NjYzNjQ2MDZ9.CUnkweojyIlcs1HmIMwb1S9bjyRxzzzD-WGyy2LPvT8'}`
                }
            }).then((res) => {
                return resolve(res);
            })
                .catch((error) => {
                    console.log("error emp", error);
                    return resolve(error);
                })
        });
        // console.log("USERS",a);
        return await a;

    }

    // //Get Employees By ID
    getEmployeeByID = async (id) => {
        const accessToken = await localStorageService.getItem('accessToken')
        console.log("accessToken", accessToken);
        const promise = new Promise((resolve, reject) => {
            axios
                .get(apiroutes.EMPLOYEES + `/${id}`, {
                    headers: {
                        Authorization: `Bearer ${accessToken}`
                    },
                })
                .then((res) => {
                    return resolve(res)
                })
                .catch((error) => {
                    console.log('error', error)
                    return resolve(error)
                })
        })
        return await promise
    }
    // //getemployeeID
    // getEmployeeID = async () => {
    //     const accessToken = await localStorageService.getItem('accessToken')
    //     console.log("accessToken", accessToken);

    //     const isValidToken = (accessToken) => {
    //         console.log("checking")
           
    //         const decodedToken = jwtDecode(accessToken)
    //         console.log("uuu:",decodedToken)
    //         return decodedToken
    //     }
    //     const userData = isValidToken()
    //     return userData
    // }

    //get user status count
    getUserStatusCount = async (params) => {
        const accessToken = await localStorageService.getItem("accessToken");
        // debugger
        console.log("accessToken", accessToken);
        const a = new Promise((resolve, reject) => {
            axios.get(apiroutes.USER_STATUS_COUNT, {
                params: params,
                headers: {
                    Authorization: `Bearer ${accessToken}`
                }
            }).then((res) => {
                return resolve(res);
            })
                .catch((error) => {
                    console.log("error in Expense", error);
                    return resolve(error);
                })
        });
        return await a;
    }

    handleApproval =  async (data) => {
        console.log("Approval",data)
        const accessToken = await localStorageService.getItem("accessToken");
        const a = new Promise((resolve, reject) => {
            axios
                .post(apiroutes.USER_APPROVAL, data, {
                    headers: {
                        Authorization: `Bearer ${accessToken}`
                    }
                })
                
                .then((res) => {
                    return resolve(res)
                })
                .catch((error) => {
                    console.log('error', error)
                    return resolve(error)
                })
        })
        console.log("res @ UA",a)
        return await a
    }

    handleDelete = async (id) => {
        const accessToken = await localStorageService.getItem('accessToken')
        console.log("accessToken", accessToken);
        const promise = new Promise((resolve, reject) => {
            axios
                .delete(apiroutes.EMPLOYEES + `/${id}`, {
                    headers: {
                        Authorization: `Bearer ${accessToken}`
                    },
                })
                .then((res) => {
                    return resolve(res)
                })
                .catch((error) => {
                    console.log('error', error)
                    return resolve(error)
                })
        })
        return await promise
    }

    // getAsignEmployees = async (params) => {
    //     const accessToken = await localStorageService.getItem("accessToken");
    //     const a = new Promise((resolve, reject) => {
    //         axios.get(apiroutes.ASIGNED_EMPLOYEES, {
    //             params: params,
    //             headers: {
    //                 Authorization: `Bearer ${accessToken}`
    //             }
    //         }).then(res => {
    //             return resolve(res);
    //         })
    //             .catch((error) => {
    //                 console.log("error", error);
    //                 return resolve(error);
    //             })
    //     });
    //     return await a;

    // }

    // createNewAssignEmployee = async (data) => {
    //     const accessToken = await localStorageService.getItem("accessToken");
    //     const a = new Promise((resolve, reject) => {
    //         axios.post(apiroutes.ASIGNED_EMPLOYEES, data, {
    //             headers: {
    //                 Authorization: `Bearer ${accessToken}`
    //             }
    //         }).then(res => {
    //             return resolve(res);
    //         })
    //             .catch((error) => {
    //                 console.log("error", error);
    //                 return resolve(error);
    //             })
    //     });
    //     return await a;

    // }

    // userResetLink = async (data) => {
    //     const a = new Promise((resolve, reject) => {
    //         axios.post(apiroutes.EMPLOYEES + "/password_reset", data).then(res => {
    //             return resolve(res);
    //         })
    //             .catch((error) => {
    //                 console.log("error", error);
    //                 return resolve(error);
    //             })
    //     });
    //     return await a;

    // }
}
export default new UserServices()
